import { ChevronLeft, ChevronRight } from "lucide-react";
import { formatMonth, shiftMonth } from "@/lib/format";

/**
 * `month` is a plain calendar month (`YYYY-MM`) by default. A page with a custom financial cycle
 * (lib/period.ts) instead passes a `YYYY-MM-DD` period start, plus `shift`/`label` built from
 * that same module - see features/dashboard/DashboardPage.tsx for the pattern.
 */
export function MonthPicker({ month, onChange, max, label = formatMonth, shift = shiftMonth }: {
  month: string;
  onChange: (month: string) => void;
  max?: string;
  label?: (month: string) => string;
  shift?: (month: string, delta: number) => string;
}) {
  const atMax = max !== undefined && month >= max;
  return (
    <div className="inline-flex h-9 items-center rounded-lg border border-border bg-surface">
      <button
        type="button"
        onClick={() => onChange(shift(month, -1))}
        aria-label="Previous month"
        className="flex h-full w-9 items-center justify-center rounded-l-lg text-ink-2 hover:bg-surface-2"
      >
        <ChevronLeft className="size-4" aria-hidden />
      </button>
      <span className="min-w-28 px-2 text-center text-sm font-medium" aria-live="polite">
        {label(month)}
      </span>
      <button
        type="button"
        onClick={() => onChange(shift(month, 1))}
        disabled={atMax}
        aria-label="Next month"
        className="flex h-full w-9 items-center justify-center rounded-r-lg text-ink-2 hover:bg-surface-2 disabled:opacity-30"
      >
        <ChevronRight className="size-4" aria-hidden />
      </button>
    </div>
  );
}
